import { ObjectsView } from "@organisms"

import { VENDOR_CREDITS_ROUTES } from "@routes/vendorCredits"

import { VendorCreditStatuses } from "@constants/choices"

export default function VendorCreditObjectsViewTabs() {
    return (
        <ObjectsView.Tabs>
            <ObjectsView.Tab
                id="all_open"
                phase="open"
                title="All Open"
                isDefaultActiveTabForPhase={true}
                endpointKwargs={[
                    ["status", VendorCreditStatuses.pending],
                    ["status", VendorCreditStatuses.recorded],
                    ["ordering", "date_issued"],
                ]}
                listEndpoint={VENDOR_CREDITS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={VENDOR_CREDITS_ROUTES.COUNT}
            />
            <ObjectsView.Tab
                id="pending"
                phase="open"
                title="Pending"
                endpointKwargs={[
                    ["status", VendorCreditStatuses.pending],
                    ["ordering", "date_issued"],
                ]}
                listEndpoint={VENDOR_CREDITS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={VENDOR_CREDITS_ROUTES.COUNT}
            />
            <ObjectsView.Tab
                id="recorded"
                phase="open"
                title="Recorded"
                endpointKwargs={[
                    ["status", VendorCreditStatuses.recorded],
                    ["ordering", "date_issued"],
                ]}
                listEndpoint={VENDOR_CREDITS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={VENDOR_CREDITS_ROUTES.COUNT}
            />
            <ObjectsView.Tab
                id="all_closed"
                phase="closed"
                title="All Closed"
                isDefaultActiveTabForPhase={true}
                endpointKwargs={[
                    ["status", VendorCreditStatuses.consumed],
                    ["status", VendorCreditStatuses.voided],
                    ["ordering", "-date_issued"],
                ]}
                listEndpoint={VENDOR_CREDITS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={VENDOR_CREDITS_ROUTES.COUNT}
            />
            <ObjectsView.Tab
                id="consumed"
                phase="closed"
                title="Consumed"
                endpointKwargs={[
                    ["status", VendorCreditStatuses.consumed],
                    ["ordering", "-date_issued"],
                ]}
                listEndpoint={VENDOR_CREDITS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={VENDOR_CREDITS_ROUTES.COUNT}
            />
            <ObjectsView.Tab
                id="voided"
                phase="closed"
                title="Voided"
                endpointKwargs={[
                    ["status", VendorCreditStatuses.voided],
                    ["ordering", "-date_issued"],
                ]}
                listEndpoint={VENDOR_CREDITS_ROUTES.LIGHTWEIGHT_LIST}
                countEndpoint={VENDOR_CREDITS_ROUTES.COUNT}
            />
        </ObjectsView.Tabs>
    )
}
